import type { FaireProductEntity } from "../../entity_types/product";

export const p_gt6p2sq5r2: FaireProductEntity = {
  token: "p_gt6p2sq5r2",
  type: "product",
  name: "Solid Color Long Sleeve Suit Straight Leg Pants Set",
  brandToken: "b_gunybtdwvh",
  brandName: "FurDecoration",
  imageUrl:
    "https://cdn.faire.com/fastly/47b69c03106f5d2ff30b1d91fbf298685040fc245b4d4d363b7127ec4a1c95c2.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8e253446e90aa39596a3f533fe9df1b5508cb33b949e83bf258ec37cc9ada453.jpeg",
    "https://cdn.faire.com/fastly/d02c2acd625fab4e961858f458ca133a349ad60d34ff434a68ee8790d9584290.jpeg",
    "https://cdn.faire.com/fastly/0a572d2e66a02f71294a11f7336cc79b508a634f3599a60c5897bf1d9c2a395d.jpeg",
    "https://cdn.faire.com/fastly/2d1d618a6fef63a1af0da157e40a919111ab225038e1222df988c3fb7b593f3d.jpeg",
    "https://cdn.faire.com/fastly/5d0a9f21c3985f3e6c10b7358474c569366e9f18123f5bfc224cccb82db2a120.jpeg",
    "https://cdn.faire.com/fastly/8ff940ca0efc265373be2c0567998d6c6bbae10e373d4850df3ec44c35e294a9.jpeg",
    "https://cdn.faire.com/fastly/0e56aab10e06c99b6a233f494bb07a2f134fa6bf3779d983db62f2ada96bc503.jpeg",
    "https://cdn.faire.com/fastly/6901138b2baa0b94d24803574cd1f77c7d34d7be66611640be2151e7a113671d.jpeg",
    "https://cdn.faire.com/fastly/42268fe43cca6702e2647b320a0a41226c23b3feb9d4ea1bb4667089d2f17db1.jpeg",
    "https://cdn.faire.com/fastly/5d31c90613b427ec2405ab22e60a4cacf94acc1c8cb999f2d1cbae3d8f889cce.jpeg",
    "https://cdn.faire.com/fastly/86d7f71f9170183edb9f0a3d5eb3819fee8aafcf6a033b5e6d20d318dbf74d5f.jpeg",
  ],
  priceDollars: 29.49,
  description:
    "Material:Dacron\n\nStyle:Loose,Intellectual,Look-younger\n\nFeature:Plain,Zipper\n\nNeckline:Tailored\n\nOccasion:Office,Workwear Suits,Urban,Simple,Formal,Girlish Sweetness,Light Maturity,Stylish Selection,Leisure Fashion\n\nSeasons:Spring,Autumn\n\nType:Sets\n\nSleeve Length:Long Sleeve\n\nSleeve Style:Raglan Sleeve\n\nSize S (inch) : Pants length= 42.51 ; Bust= 36.66 ; Waist= 25.74 ; Shoulder= 15.21 ; Sleeve= 22.62 ; Hips= 37.44 ; Top Length= 27.30 ; \n\nSize M (inch) : Pants length= 42.90 ; Bust= 38.22 ; Waist= 27.30 ; Shoulder= 15.60 ; Sleeve= 23.01 ; Hips= 39.00 ; Top Length= 27.69 ; \n\nSize L (inch) : Pants length= 43.29 ; Bust= 39.78 ; Waist= 28.86 ; Shoulder= 15.99 ; Sleeve= 23.40 ; Hips= 40.56 ; Top Length= 28.08 ; \n\nSize XL (inch) : Pants length= 43.68 ; Bust= 41.34 ; Waist= 30.42 ; Shoulder= 16.38 ; Sleeve= 23.79 ; Hips= 42.12 ; Top Length= 28.47 ; \n\nSize 2XL (inch) : Pants length= 44.07 ; Bust= 42.90 ; Waist= 31.98 ; Shoulder= 16.77 ; Sleeve= 24.18 ; Hips= 43.68 ; Top Length= 28.86 ; \n\nSize 3XL (inch) : Pants length= 44.46 ; Bust= 44.46 ; Waist= 33.54 ; Shoulder= 17.16 ; Sleeve= 24.57 ; Hips= 45.24 ; Top Length= 29.25 ; \n",
  tags: [],
  msrpDollars: 58.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:26:51.048Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
